import angular from 'angular';
import 'stackframe';
import ErrorStackParser from 'error-stack-parser';

(function() {
    'use strict';

    angular.module('app.core').factory('kissStackTraceService', kissStackTraceService);

    kissStackTraceService.$inject = ['$http', '$window', '$log', 'CONF', 'AuthSvc'];

    function kissStackTraceService($http, $window, $log, CONF, AuthSvc) {
        var MAX_POST_BY_SESSION = 10;
        var currentPostNbr = 0;

        var exports = {
            sendStackTrace: sendStackTrace
        };

        return exports;

        function sendStackTrace(exception, cause) {
            // Verifier si on atteint le nombre de post max
            if (currentPostNbr < MAX_POST_BY_SESSION && AuthSvc.isAuthenticated()) {
                var err;
                try {
                    err = ErrorStackParser.parse(exception).toString();
                } catch (e) {
                    err = exception.toString();
                }
                // Notification du serveur de l'erreur Javascript
                var errorData = {
                    strackTrace: err,
                    cause: cause,
                    url: $window.location.href
                };

                currentPostNbr++;
                $http.post(CONF.apiContext + CONF.apiBaseUrl + '/v1/audits/js-error-log', errorData).then(
                    function() {},
                    function() {
                        $log.error('Erreur de logging de la stacktrace ' + err);
                    }
                );
            }
        }
    }
})();
